import { Component, OnInit, ViewChild } from '@angular/core';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { RequestService } from 'src/app/services/requests.service';
import { AgGridAngular } from 'ag-grid-angular';
import { ActivatedRoute } from '@angular/router';
import { Buffer } from 'buffer';

@Component({
  selector: 'app-experiment',
  templateUrl: './experiment.component.html',
  styleUrls: ['./experiment.component.scss']
})

export class ExperimentComponent implements OnInit {

  public fileName = history.state.fileName;
  public id;
  public gridApi;
  public gridColumnApi;
  public rowData: any[] = [];
  public arrayBuffer: any | ArrayBuffer;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: true,
  };
  public autoGroupColumnDef: ColDef = {
    minWidth: 150,
  };
  public groupDefaultExpanded = 1;


  public gridOptions: GridOptions = {}


  public columnDefs: ColDef[] = [];
  public columnFields: any[] = [];
  public columns: any[] = [];
  public numberParams: any = {
    buttons: ['reset', 'apply'],
    filterOptions: ["equals", "notEqual", "greaterThan", "lessThan", "greaterThanOrEqual", "lessThanOrEqual", "inRange"]
  };

  gridOption: any = {};


  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  constructor(private req: RequestService<any>, private route: ActivatedRoute) { }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');

    this.req.getExperiments(this.id).subscribe((res) => {
      const base64String = res.file_bytes;

      // Convert base64 string to binary
      const binaryString = window.atob(base64String);

      // Convert binary string to ArrayBuffer
      const arrayBuffer = new ArrayBuffer(binaryString.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }

      // Create a Blob from the ArrayBuffer
      const blob = new Blob([arrayBuffer], { type: 'text/csv' });
      console.log(blob)
    })
  }
}